import classNames from 'classnames'
import React from 'react'
import { cloudflareImageLoader } from '@dustin-web/microsite-components/src/image/cloudflare-loader'
import { Image } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import { ArticleCard, ArticleCardClient, ArticleCardHorizontal, type Article } from './index'

type ArticleCardListProps = {
  articlesList?: Article[]
  showFourCardsPerRow?: boolean
  maxNumberOfArticles?: number
  listCategory?: string
  hideCategory?: boolean
  hideTags?: boolean
  hideDate?: boolean
  onCardClick?: () => void
}

enum ArticleCardType {
  Horizontal = 'CardArticleHorizontalBlock',
  Vertical = 'CardArticleVerticalBlock',
}

export const ArticleCardList = ({
  articlesList = [],
  showFourCardsPerRow = false,
  maxNumberOfArticles,
  listCategory,
  hideCategory = false,
  hideTags = false,
  hideDate = false,
  onCardClick,
}: ArticleCardListProps) => {
  if (!articlesList?.length) {
    return null
  }
  const articlesSliced = articlesList.slice(0, maxNumberOfArticles ?? articlesList.length)

  const articleType =
    articlesSliced.length === 1 ? ArticleCardType.Horizontal : ArticleCardType.Vertical

  if (articleType === ArticleCardType.Horizontal) {
    const [props] = articlesSliced
    return <ArticleCardHorizontal {...props} />
  }
  return (
    <div className="row sm-gutters">
      {articlesSliced.map(
        ({ title, categoryName, tags, postDateText, summary, url, mainImage, youTubeId }, key) => (
          <div
            key={title + key}
            className={classNames(
              'u-mb-16',
              showFourCardsPerRow ? 'col-md-6 col-lg-3' : 'col-md-4'
            )}>
            {onCardClick ? (
              <ArticleCardClient
                title={title}
                categoryName={hideCategory ? undefined : categoryName || listCategory}
                tags={hideTags ? undefined : tags}
                postDateText={hideDate ? undefined : postDateText}
                summary={summary}
                url={url}
                mainImage={
                  mainImage
                    ? ({
                        ...mainImage,
                        url: cloudflareImageLoader({
                          src: mainImage.relativeUrl || '',
                          width: 600,
                        }),
                      } as Image)
                    : null
                }
                youTubeId={youTubeId}
                onCardClick={onCardClick}
              />
            ) : (
              <ArticleCard
                title={title}
                categoryName={hideCategory ? undefined : categoryName || listCategory}
                tags={hideTags ? undefined : tags}
                postDateText={hideDate ? undefined : postDateText}
                summary={summary}
                url={url}
                mainImage={
                  mainImage
                    ? ({
                        ...mainImage,
                        url: cloudflareImageLoader({
                          src: mainImage.relativeUrl || '',
                          width: 600,
                        }),
                      } as Image)
                    : null
                }
                youTubeId={youTubeId}
              />
            )}
          </div>
        )
      )}
    </div>
  )
}
